import type { SchedulerRecurringEventsPluginInterface } from '@mui/x-scheduler-internals/internals';
import { parseRRule, isSameRRule } from '../utils/recurring-events/rRuleString';
import { getRecurringEventOccurrencesForVisibleDays } from '../utils/recurring-events/getRecurringEventOccurrencesForVisibleDays';
import { updateRecurringEvent } from '../utils/recurring-events/updateRecurringEvent';
import { deleteRecurringEvent } from '../utils/recurring-events/deleteRecurringEvent';
import { applyDataTimezoneToEventUpdate } from '../utils/recurring-events/applyDataTimezoneToEventUpdate';
import { computePresets, getDefaultPresetKey } from '../utils/recurring-events/presets';

export const schedulerRecurringEventsPlugin = {
  parseRRule,
  getOccurrencesForVisibleDays: getRecurringEventOccurrencesForVisibleDays,
  updateRecurringEvent,
  deleteRecurringEvent,
  applyDataTimezoneToEventUpdate,
  computePresets,
  getDefaultPresetKey,
  isSameRRule,
} as const satisfies SchedulerRecurringEventsPluginInterface;
